import type { AxiosResponse } from 'axios';
import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { ChatAppApiClient } from '@trinity/chat/api';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';

type Props = ITranscriptId;

export const useTranscriptEntities = (props: Props, options: Options = {}) => {
  const apiClient = useChatApiClient();

  return useQuery({
    queryKey: ['transcript-entities', props],
    queryFn: ({ queryKey }) => {
      return apiClient.transcripts.getTranscriptEntities(queryKey[1]);
    },
    ...options,
  });
};

type Data = Awaited<ReturnType<ChatAppApiClient['transcripts']['getTranscriptEntities']>>;
type QK = readonly [string, Props];

type Options = Omit<UseQueryOptions<Data, AxiosResponse, Data, QK>, 'queryKey' | 'queryFn'>;